<template>
  <v-main>
    <header-components></header-components>
    <title-components></title-components>
    <v-container
      class="mx-auto mt-6"
      style="max-width: 1200px;"
    >
      <div v-show="covidCertificatePath !== ''">
        <v-card
          class="py-2"
          elevation="0"
          outlined
          tile
        >
          <v-row justify="center" align-content="center" class="mt-3" dense>
            <v-btn
              rounded
              x-large min-width="150px"
              color="doorAccentColor"
              class="mb-4 mx-4"
              :loading="isDownloading"
              @click="toCertificatePage"
            >証明書表示
            </v-btn>
          </v-row>
          <v-row dense>
            <v-col align="center" class="text-sm-body-2 text-caption">
            「証明書表示」ボタンを押下していただき画面キャプチャを撮っていただくようお願いいたします。<br>
            （iOSアプリ・モバイルブラウザをご利用の方は画像長押し、PCをご利用の方は右クリックで画像を保存することも可能です。）</v-col>
          </v-row>
        </v-card>
      </div>
      <h3>登録内容確認</h3>
      <div v-show="hasRiskOfSerious" class="my-6">
        <span class="text-red font-weight-bold">大変恐れ入りますが、重症化リスクに当てはまる方の受診はできません。</span>
      </div>
      <div v-show="isOutOfAge" class="my-6">
        <span class="text-red font-weight-bold">大変恐れ入りますが、対象者は13~64歳のため受診はできません。</span>
      </div>
      <div v-show="!hasRiskOfSerious && !isOutOfAge">
        <v-card
          class="mx-1 mt-6 px-5 py-2"
          elevation="5"
          outlined
        >
          <v-card-title>
            <strong>基本情報</strong>
          </v-card-title>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                氏名<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ name }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                フリガナ<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ kana }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                年齢属性<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ age }}
            </v-col>
          </v-row>
          <div v-show="age === '13歳以上18歳未満'">
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                保護者の名前<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ nameOfParent }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                保護者の電話番号<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ telOfParent }}
            </v-col>
          </v-row>
          </div>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                証明証各種
              </v-alert>
            </v-col>
          </v-row>
          <v-row v-for="(item, index) in certificates" :key="`certificates_${index}`"
                no-gutters justify="start" align-content="center">
            <v-col v-if="item == 'その他'" align="start" class="ml-4">
              {{ item }}: {{ causesOfOtherRisk }}
            </v-col>
            <v-col v-else align="start" class="ml-4">
              {{ item }}
            </v-col>
          </v-row>
        </v-card>
        <v-card
          class="mx-1 mt-6 px-5 py-2"
          elevation="5"
          outlined
        >
          <v-card-title>
            <strong>重症化リスク</strong>
          </v-card-title>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                重症化リスク要因_既往歴<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ hasDuringTreatment }}
            </v-col>
          </v-row>
          <div v-show="hasDuringTreatment == '有'">
            <v-row  no-gutters justify="start" align-content="center" class="mt-4">
              <v-col align="start">
                <v-alert
                  class="py-1 mt-4 rounded-0 font-weight-bold"
                  border="left"
                  colored-border
                >
                  重症化リスク要因_既往歴(病名)
                </v-alert>
              </v-col>
            </v-row>
            <v-row v-show="hasDuringTreatment == '有'" v-for="(item, index) in riskOfSerious" :key="`certificates_${index}`"
                  no-gutters justify="start" align-content="center">
              <v-col v-if="item == 'その他'" align="start" class="ml-4">
                {{ item }}: {{ riskOfSeriousOther }}
              </v-col>
              <v-col v-else align="start" class="ml-4">
                {{ item }}
              </v-col>
            </v-row>
          </div>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                重症化リスク要因_肥満(BMI30以上) <span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ obesityRisk }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                重症化リスク要因_妊娠 <span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ pregnancyRisk }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                重症化リスク要因_喫煙歴 <span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ smokingRisk }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                重症化リスク要因_その他 <span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ otherRisk }}
            </v-col>
          </v-row>
        </v-card>
        <v-card
          class="mx-1 mt-6 px-5 py-2"
          elevation="5"
          outlined
        >
          <v-card-title>
            <strong>問診</strong>
          </v-card-title>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                検査_検体採取日 <span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ inspectionDate }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                新型コロナウイルスワクチン_接種歴  <span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ vaccinationHistory }}
            </v-col>
          </v-row>
          <div v-show="vaccinationHistory !== '0回' && vaccinationHistory !== '不明'">
            <v-row no-gutters justify="start" align-content="center" class="mt-4">
              <v-col align="start">
                <v-alert
                  class="py-1 mt-4 rounded-0 font-weight-bold"
                  border="left"
                  colored-border
                >
                  新型コロナウイルスワクチン_直近接種年月日 <span class="text-red"><strong> *</strong></span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center">
              <v-col align="start" class="ml-4">
                {{ coronaVaccinationDate }}
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center" class="mt-4">
              <v-col align="start">
                <v-alert
                  class="py-1 mt-4 rounded-0 font-weight-bold"
                  border="left"
                  colored-border
                >
                  新型コロナウイルスワクチン_直近接種 <span class="text-red"><strong> *</strong></span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center">
              <v-col align="start" class="ml-4">
                {{ coronaVaccineName }}
              </v-col>
            </v-row>
          </div>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                インフルエンザワクチン_1年以内の接種歴  <span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ fluVaccinationHistory }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                症状の有無 <span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ symptoms }}
            </v-col>
          </v-row>
          <div v-show="symptoms === '有'">
            <v-row no-gutters justify="start" align-content="center" class="mt-4">
              <v-col align="start">
                <v-alert
                  class="py-1 mt-4 rounded-0 font-weight-bold"
                  border="left"
                  colored-border
                >
                  症状_発生した日 <span class="text-red"><strong> *</strong></span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center">
              <v-col align="start" class="ml-4">
                {{ dateOfOnset }}
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center" class="mt-4">
              <v-col align="start">
                <v-alert
                  class="py-1 mt-4 rounded-0 font-weight-bold"
                  border="left"
                  colored-border
                >
                  症状_発熱 <span class="text-red"><strong> *</strong></span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center">
              <v-col align="start" class="ml-4">
                {{ fever }}
              </v-col>
            </v-row>
            <div v-show="fever === '37.5度以上'">
              <v-row no-gutters justify="start" align-content="center" class="mt-4">
                <v-col align="start">
                  <v-alert
                    class="py-1 mt-4 rounded-0 font-weight-bold"
                    border="left"
                    colored-border
                  >
                    症状_発熱時の体温 <span class="text-red"><strong> *</strong></span>
                  </v-alert>
                </v-col>
              </v-row>
              <v-row no-gutters justify="start" align-content="center">
                <v-col align="start" class="ml-4">
                  {{ feverNum }}度
                </v-col>
              </v-row>
            </div>
            <v-row no-gutters justify="start" align-content="center" class="mt-4">
              <v-col align="start">
                <v-alert
                  class="py-1 mt-4 rounded-0 font-weight-bold"
                  border="left"
                  colored-border
                >
                  症状_せき<span class="text-red"><strong> *</strong></span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center">
              <v-col align="start" class="ml-4">
                {{ cough }}
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center" class="mt-4">
              <v-col align="start">
                <v-alert
                  class="py-1 mt-4 rounded-0 font-weight-bold"
                  border="left"
                  colored-border
                >
                  症状_せき以外の呼吸器症状<span class="text-red"><strong> *</strong></span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center">
              <v-col align="start" class="ml-4">
                {{ otherThanCough }}
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center" class="mt-4">
              <v-col align="start">
                <v-alert
                  class="py-1 mt-4 rounded-0 font-weight-bold"
                  border="left"
                  colored-border
                >
                  症状_倦怠感<span class="text-red"><strong> *</strong></span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center">
              <v-col align="start" class="ml-4">
                {{ senseOfFatigue }}
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center" class="mt-4">
              <v-col align="start">
                <v-alert
                  class="py-1 mt-4 rounded-0 font-weight-bold"
                  border="left"
                  colored-border
                >
                  症状_頭痛<span class="text-red"><strong> *</strong></span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center">
              <v-col align="start" class="ml-4">
                {{ headache }}
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center" class="mt-4">
              <v-col align="start">
                <v-alert
                  class="py-1 mt-4 rounded-0 font-weight-bold"
                  border="left"
                  colored-border
                >
                  症状_嘔気/嘔吐<span class="text-red"><strong> *</strong></span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center">
              <v-col align="start" class="ml-4">
                {{ nausea }}
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center" class="mt-4">
              <v-col align="start">
                <v-alert
                  class="py-1 mt-4 rounded-0 font-weight-bold"
                  border="left"
                  colored-border
                >
                  症状_下痢<span class="text-red"><strong> *</strong></span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center">
              <v-col align="start" class="ml-4">
                {{ diarrhea }}
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center" class="mt-4">
              <v-col align="start">
                <v-alert
                  class="py-1 mt-4 rounded-0 font-weight-bold"
                  border="left"
                  colored-border
                >
                  症状_結膜炎<span class="text-red"><strong> *</strong></span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center">
              <v-col align="start" class="ml-4">
                {{ conjunctivitis }}
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center" class="mt-4">
              <v-col align="start">
                <v-alert
                  class="py-1 mt-4 rounded-0 font-weight-bold"
                  border="left"
                  colored-border
                >
                  症状_咽頭痛<span class="text-red"><strong> *</strong></span>
                </v-alert>
              </v-col>
            </v-row>
            <v-row no-gutters justify="start" align-content="center">
              <v-col align="start" class="ml-4">
                {{ pharyngitis }}
              </v-col>
            </v-row>
          </div>
        </v-card>
        <v-card
          class="mx-1 my-6 px-5 py-2"
          elevation="5"
          outlined
        >
          <v-card-title>
            <strong>濃厚接触</strong>
          </v-card-title>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                感染の可能性_インフルエンザ患者の方との接触または身近での流行<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ fulPatientContact }}
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center" class="mt-4">
            <v-col align="start">
              <v-alert
                class="py-1 mt-4 rounded-0 font-weight-bold"
                border="left"
                colored-border
              >
                感染の可能性_新型コロナウイルス患者の方との接触または身近での流行<span class="text-red"><strong> *</strong></span>
              </v-alert>
            </v-col>
          </v-row>
          <v-row no-gutters justify="start" align-content="center">
            <v-col align="start" class="ml-4">
              {{ coronaPatientContact }}
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-container>
    <footer-components></footer-components>
    <v-dialog
      v-model="notFoundModal"
      width="400"
    >
      <v-card>
        <v-card-title class="bg-doorMainColor">エラー</v-card-title>
        <v-card-text style="margin: 1rem auto;">
          <div>指定したデータは存在しません。</div>
          <div>URLをお確かめの上再度アクセスしてください。</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-spacer></v-spacer>
        <v-row justify="center" align-content="center" class="my-3">
            <v-btn
              dark
              color="doorAccentColor"
              @click="notFoundModal = false"
            >
            閉じる
            </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="errorModal"
      width="400"
    >
      <v-card>
        <v-card-title class="bg-doorMainColor">エラー</v-card-title>
        <v-card-text style="margin: 1rem auto;">
          <div>通信エラーが発生しました。</div>
          <div>URLをお確かめの上再度アクセスしてください。</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-spacer></v-spacer>
        <v-row justify="center" align-content="center" class="my-3">
            <v-btn
              dark
              color="doorAccentColor"
              @click="errorModal = false"
            >
            閉じる
            </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<script>
import { defineComponent, computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Logger } from 'aws-amplify'
import { useScreenOperation } from '@/func/useScreenOperation'
import { useStore } from 'vuex'
import HeaderComponents from '@/components/InterviewHeader.vue'
import FooterComponents from '@/components/InterviewFooter.vue'
import TitleComponents from '@/components/InterviewTitle.vue'
import { usePostMessage } from '@/func/usePostMessage';
import { useApiParams } from '@/func/useApiParams';

const logger = new Logger('AdvanceDetail')

export default defineComponent({
  components: {
    'header-components': HeaderComponents,
    'footer-components': FooterComponents,
    'title-components': TitleComponents,
  },
  setup() {
    logger.info('Advance detail')
    const { scrollToTop } = useScreenOperation()
    scrollToTop()
    const store = useStore()

    // トークンの状態監視
    const token = computed({ get: () => store.state.apiParams.jwtToken })
    watch(token, (value) => {
      logger.info('Updated JWT', value)
      fetchInterview()
    })
    useApiParams().save()
    usePostMessage().receiveToken()

    const name = computed(() => store.state.advanceInterview.name)
    const kana = computed(() => store.state.advanceInterview.kana)
    const age = computed(() => store.state.advanceInterview.age)
    const otherAge = computed(() => store.state.advanceInterview.otherAge)
    const nameOfParent = computed(() => store.state.advanceInterview.nameOfParent)
    const telOfParent = computed(() => store.state.advanceInterview.telOfParent)
    const certificates = computed(() => store.state.advanceInterview.certificates)

    // 重症化リスク
    const hasDuringTreatment = computed(() => store.state.advanceInterview.hasDuringTreatment)
    const riskOfSerious = computed(() => store.state.advanceInterview.riskOfSerious)
    const riskOfSeriousOther = computed(() => store.state.advanceInterview.riskOfSeriousOther)
    const obesityRisk = computed(() => store.state.advanceInterview.obesityRisk)
    const pregnancyRisk = computed(() => store.state.advanceInterview.pregnancyRisk)
    const smokingRisk = computed(() => store.state.advanceInterview.smokingRisk)
    const otherRisk = computed(() => store.state.advanceInterview.otherRisk)

    //問診
    const inspectionDate = computed(() => store.state.advanceInterview.inspectionDate)
    const kitName = computed(() => store.state.advanceInterview.kitName)
    const searchMethod = computed(() => store.state.advanceInterview.searchMethod)
    const searchOtherMethod = computed(() => store.state.advanceInterview.searchOtherMethod)
    const vaccinationHistory = computed(() => store.state.advanceInterview.vaccinationHistory)
    const coronaVaccinationDate = computed(() => store.state.advanceInterview.coronaVaccinationDate)
    const coronaVaccineName = computed(() => store.state.advanceInterview.coronaVaccineName)
    const fluVaccinationHistory = computed(() => store.state.advanceInterview.fluVaccinationHistory)
    const symptoms = computed(() => store.state.advanceInterview.symptoms)
    const dateOfOnset = computed(() => store.state.advanceInterview.dateOfOnset)
    const fever = computed(() => store.state.advanceInterview.fever)
    const feverNum = computed(() => store.state.advanceInterview.feverNum)
    const cough = computed(() => store.state.advanceInterview.cough)
    const otherThanCough = computed(() => store.state.advanceInterview.otherThanCough)
    const senseOfFatigue = computed(() => store.state.advanceInterview.senseOfFatigue)
    const headache = computed(() => store.state.advanceInterview.headache)
    const nausea = computed(() => store.state.advanceInterview.nausea)
    const diarrhea = computed(() => store.state.advanceInterview.diarrhea)
    const conjunctivitis = computed(() => store.state.advanceInterview.conjunctivitis)
    const pharyngitis = computed(() => store.state.advanceInterview.pharyngitis)

    //渡航歴
    const travelHistory = computed(() => store.state.advanceInterview.travelHistory)
    const departureDate = computed(() => store.state.advanceInterview.departureDate)
    const entryDate = computed(() => store.state.advanceInterview.entryDate)
    const destination = computed(() => store.state.advanceInterview.destination)

    //濃厚接触
    const fulPatientContact = computed(() => store.state.advanceInterview.fulPatientContact)
    const coronaPatientContact = computed(() => store.state.advanceInterview.coronaPatientContact)
    const hasIntensiveContact = computed(() => store.state.advanceInterview.hasIntensiveContact)
    const causeIntensiveContact = computed(() => store.state.advanceInterview.causeIntensiveContact)
    const causeIntensiveContactOther = computed(() => store.state.advanceInterview.causeIntensiveContactOther)
    const placeIntensiveContact = computed(() => store.state.advanceInterview.placeIntensiveContact)
    const placeIntensiveContactOther = computed(() => store.state.advanceInterview.placeIntensiveContactOther)

    //陽性確認証明省
    const covidCertificatePath = computed(() => store.getters['covidCertificate/covidCertificatePath'])
    const hasRiskOfSerious = computed(() => {
      return (
        obesityRisk.value === '有' ||
        pregnancyRisk.value === '有' ||
        hasDuringTreatment.value === '有' ||
        otherRisk.value == '有'
      )
    })
    const isOutOfAge = computed(() => age.value === '13歳未満' || age.value === '65歳以上')

    //初回ロード処理関連
    const notFoundModal = ref(false)
    const errorModal    = ref(false)
    const route         = useRoute()
    const fetchInterview = async () => {
      try {
        await store.dispatch('advanceInterview/getInterviewById', { id : route.params.id, jwtToken: token.value })
        if (name.value === '') notFoundModal.value = true
      } catch (e) {
        errorModal.value = true
        logger.info(e)
      }
    }
    // 証明書ダウンロード処理
    const router = useRouter();
    const toCertificatePage = async() => {
      try {
        isDownloading.value = true
        const accessToken = store.getters['apiParams/jwtToken']
        const treatmentConsultationSeq = store.getters['apiParams/treatmentConsultationSeq']
        await store.dispatch('covidCertificate/fetchImageData', {
          accessToken: accessToken,
          treatmentConsultationSeq: treatmentConsultationSeq
        });
        isDownloading.value = false
        router.push('/interview/certificate')
      } catch(e) {
        logger.error(e)
        isDownloading.value = false
        errorModal.value = true
      }
    }
    const isDownloading = ref(false)
    const downloadCovidCertificate = async() => {
      const accessToken = store.getters['apiParams/jwtToken']
      const treatmentConsultationSeq = store.getters['apiParams/treatmentConsultationSeq']
      isDownloading.value = true
      try {
        await store.dispatch('covidCertificate/downloadImage', {
          accessToken: accessToken,
          treatmentConsultationSeq: treatmentConsultationSeq
        })
        isDownloading.value = false
      } catch(e) {
        logger.error(e)
        isDownloading.value = false
        errorModal.value = true
      }
    }
    return {
      name,
      kana,
      age,
      otherAge,
      nameOfParent,
      telOfParent,
      certificates,
      riskOfSerious,
      riskOfSeriousOther,
      obesityRisk,
      pregnancyRisk,
      smokingRisk,
      otherRisk,
      hasDuringTreatment,
      inspectionDate,
      kitName,
      searchMethod,
      vaccinationHistory,
      coronaVaccinationDate,
      coronaVaccineName,
      fluVaccinationHistory,
      symptoms,
      dateOfOnset,
      fever,
      feverNum,
      cough,
      otherThanCough,
      senseOfFatigue,
      headache,
      nausea,
      diarrhea,
      conjunctivitis,
      pharyngitis,
      travelHistory,
      departureDate,
      entryDate,
      destination,
      fulPatientContact,
      coronaPatientContact,
      hasIntensiveContact,
      causeIntensiveContact,
      causeIntensiveContactOther,
      placeIntensiveContact,
      placeIntensiveContactOther,
      notFoundModal,
      errorModal,
      hasRiskOfSerious,
      isOutOfAge,
      searchOtherMethod,
      covidCertificatePath,
      isDownloading,
      downloadCovidCertificate,
      toCertificatePage
    }
  }
})

</script>

<style scoped>
@media screen and (max-width: 960px) {
  .btn-area button{
    min-width: 70%!important;
  }
  .send-btn-area button{
    min-width: 70%!important;
  }
}
</style>
